const braintree = require('braintree-web');
const { assign } = require('lodash');

class PaypalService {
    constructor(restangular, $q) {
        this.$q = $q;
        this.api = restangular.one('Paypal');
        this.dpApi = restangular.one('DigitalPay');
        this.integration = null;
        this.deviceData = null;
    }

    setup(paypal, callBack, clientToken = null) {
        const deferred = this.$q.defer();
        this.token = null;
        this.nonce = null;
        this.deviceData = null;
        this.customerEmail = null;
        this.integration = null;

        const options = assign({
            singleUse: false,
            displayName: 'WoolWorths',
            enableShippingAddress: false,
            enableBillingAddress: false,
            headless: true,
        }, paypal);

        if (!clientToken) {
            this.api.post('Token').then((response) => {
                this.setupBrainTree(response.ClientToken, options, deferred, callBack);
            });
        } else {
            this.setupBrainTree(clientToken, options, deferred, callBack);
        }

        return deferred.promise;
    }

    setupBrainTree(clientToken, options, deferred, callBack) {
        braintree.setup(clientToken, 'custom', {
            dataCollector: {
                paypal: true,
            },
            onReady: (integration) => {
                this.integration = integration;
                this.deviceData = integration.deviceData;
                deferred.resolve({ hasError: false });
            },
            onError: (type, message) => {
                deferred.reject({ hasError: true, type, message });
            },
            onPaymentMethodReceived: (payload) => {
                // retrieve nonce from payload.nonce
                if (callBack != null) {
                    callBack(payload);
                }
            },
            paypal: options,
        });
    }

    initAuthFlow() {
        this.integration.paypal.initAuthFlow();
    }

    getCurrentCustomer() {
        return this.api.post('Customer');
    }

    getDeviceData() {
        return this.deviceData;
    }

    removeAccount() {
        return this.api.post('Remove').then(() => {
            this.token = null;
            this.nonce = null;
        });
    }

    isReady() {
        return !!this.integration;
    }

    isTokenized() {
        return !!this.token;
    }

    linkAccount(nonce, email, deviceData) {
        return this.api.post('Link', { Nonce: nonce, Email: email, DeviceData: deviceData }).then((payload) => {
            this.token = payload.Token;
            this.customerEmail = email;
            return payload;
        });
    }

    linkAccountWithDp(nonce) {
        return this.dpApi.post('Paypal/Link', { Nonce: nonce });
    }

    resolveAddress(details) {
        if (details.shippingAddress) {
            return details.shippingAddress;
        }

        if (details.billingAddress) {
            return details.billingAddress;
        }

        return null;
    }
}

module.exports = PaypalService;



// WEBPACK FOOTER //
// ./src/common/paypal/paypal.service.js